import {Component} from 'react';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import securityQuestionCodes from './datasets/security_question_code';
import editPassword from '../../objects/CommonUse/edit_password';
//import SendEmail from '../../objects/CommonUse/send_email-save';
import PasswordChecklist from "react-password-checklist"
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import setTempTokenForFetch from '../../objects/CommonUse/set_temp_token_for_fetch';


class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
             test: "",
             sessionStoragePfx: "userVerifyCode",
             updatesComplete: false,
             pageStatus: "initial",
             subProcess: "ForgotPassword",
             environment: Config.dataURL.currentEnv,
          };
        this.passwordErrors = false;
        this.password = "";
        this.confirmPassword = "";
        this.errorCount = 0;
        this.errorTable = [];
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.errorMessage = "";
        this.securityAnswerError = 0;
        this.preProcess();
    }

    // password checklist....  refer to the register form for a complete list of possible rules

    preProcess(){
        this.resetErrorTable();
        const securityQuestionObj = securityQuestionCodes.find(elem => elem.code === this.props.securityQuestion);
        if (securityQuestionObj){
            this.securityQuestionText = securityQuestionObj.questionText;
        }else{
            this.securityQuestionText = this.props.securityQuestion;
        }
    }

    render() { 
        if (this.state.updatesComplete === true){
            const credentials = {username: this.props.username, password: this.password};
            this.props.passwordResetComplete(credentials);
        }
    return <>
          
            <form id="forgotPasswordForm">
            {this.state.pageStatus === "initial" ?
                <span>
                    <div className="forgot-password-form px-2 pb-2"> 
                        <h4 className="text-center font-weight-bold">Reset User Password</h4>
                        <div className="mt-4">
                            Please provide the answer to your security question.
                        </div>
                        <div className="form-group text-left mt-4 mb-0">
                            <label>{this.securityQuestionText} </label>
                            <input type="text" className="form-control" id="securityAnswer" 
                                    placeholder="Security Question Answer"/>
                            <div className="text-danger font-weight-bold">{this.errorMessage}</div>
                        </div>
                
                        <div className="form-group my-2 text-right">
                            <button type="button" className="btn btn-primary" 
                                onClick={()=>this.processSubmit("securityAnswer")}>Submit</button>
                            <button type="button" className="ml-2 btn btn-primary" 
                                onClick={()=>this.props.closeForm()}>Close</button>
                        </div>   
                  
                    </div>
                </span>
            :
                null
            }
      
            {this.state.pageStatus === "newPassword"  ?
                <div className="forgot-password-form px-2 pb-2" >
                    <div className="form-group text-left">
                        <label className="font-weight-bold">Username</label>
                        <input type="text" className="form-control" id="newUsername" placeholder="Preferred username"
                            value={this.props.username}/>
                    </div>
                    <div className="form-group text-left mb-0">
                        <label className={this.errorTable[0].class}>New Password</label>
                        <input type="password" className="form-control" id="newPassword" placeholder="Password"
                                onChange={(val) => this.setPassword(val.target.value)}/>
                         <div className="text-danger">{this.errorTable[0].message}</div>
                    </div>
                    <div>
                        <label className={this.errorTable[1].class}>Confirm Password</label>
                        <input type="password" className="form-control" id="confirmPassword" 
                            placeholder="Confirm password"
                            onChange={(val) => this.setConfirmPassword(val.target.value)}/>
                        <div className="text-danger">{this.errorTable[1].message}</div>
                    </div>
                    <PasswordChecklist
                        rules={["minLength","specialChar","match"]}
                        minLength={8}
                        value={this.password}
                        valueAgain={this.confirmPassword}
                    />
                   <div className="form-group my-2 text-right">
                    <button type="button" className="btn btn-primary" 
                        onClick={()=>this.processSubmit("ConfirmPassword")}>Submit</button>
                    <button type="button" className="ml-2 btn btn-primary" 
                            onClick={()=>this.props.closeForm()}>Close</button>
               </div>
                 
                 </div>
                 :
                     null
            }
            </form>
             
            </>
    }


resetToInitial(){
    this.setState({pageStatus: "initial"});
}

setStatusToVerify(){
    this.setState({pageStatus: "verify"});   
}

processSubmit(stepName){
    if (stepName === "securityAnswer"){
        this.editSecurityAnswer()
    }else{
        this.editPasswords();
    }
}

editSecurityAnswer(){
    this.errorsFound = false;
    this.securityAnswer = document.getElementById("securityAnswer").value;
    if (!this.securityAnswer){
        this.errorMessage = "Security answered cannot be blank.";
        this.errorsFound = true;
    }else{
        if (this.securityAnswer !== this.props.securityAnswer){
            this.errorCount +=1;
            this.errorsFound = true;
            if (this.errorCount > 3){
                this.errorMessage = "Security answer does not match - please create a new signon.";
            }else{
                this.errorMessage = "Security answer does not match previous answer.";
            }
        }
    }
    if (this.errorsFound === true){
        this.setState({pageStatus: "initial"});
    }else{
        this.setState({pageStatus: "newPassword"});
    }
}

setPassword(password){
     this.password = password;
     this.setState({test: "password"});
}

setConfirmPassword(password){
     this.confirmPassword = password;
     this.setState({test: "confirmPassword"});
}

editPasswords(){
    this.resetErrorTable();
    this.password = document.getElementById("newPassword").value;
    this.confirmPassword = document.getElementById("confirmPassword").value;
    this.errorTable = editPassword(this.password, this.confirmPassword);
    this.passwordErrors = false;
    for (let i=0; i<this.errorTable.length; i++){
        if (this.errorTable[i].error === true){
            this.passwordErrors = true;
            break;
        }
    }
    if (this.passwordErrors === false){
          this.blocked = false;
          this.updateLogin();
    }else{
         this.setState({true: this.state.test});
    }
}

resetErrorTable(){
    this.errorTable = [
        {field: "password", error: false, message: "", class: "font-weight-bold"},
        {field: "confirmPassword", error: false, message: "", class: "font-weight-bold"}
    ]
}

handleKeyPress(e)
{
    if(e.key === "Enter")
    {
        this.checkVerifyCode();
    }
}   

updateLogin(){
    const currDateTime = getCurrentDateTime();  
    let headers = setTempTokenForFetch(this.props.username, this.password);
    const bodyObj = {
        "username": this.props.username,
        "password": this.password,
        "dateUpdated": currDateTime.date
        };
    const funcName = "updateLogin";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
         {method:'PUT', 
          headers: headers,
          body: JSON.stringify(bodyObj)})
          .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       this.passwordHasBeenUpdated();
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
}

passwordHasBeenUpdated(){
     const credentials = {username: this.props.username, password: this.password}
     this.props.passwordResetComplete(credentials);
}


}

export default ForgotPassword;